import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import FileLink from 'src/assets/images/FileLink.svg';
import styled from 'styled-components';
import { getPoImagePreview } from 'src/pages/consignmentBilling/redux/actions/index.js';
import PoImagePreview from 'src/pages/consignmentBilling/components/payment/reportPayment/AddPo/PoImagePreview.jsx';

const PoInfoView = ({ isAttachment }) => {
    const [previewImage, setPreviewImage] = useState(false);
    const dispatch = useDispatch();
    const openImagePreview = (fileName) => {
        if (fileName) {
            const object = {
                fileName,
            };
            dispatch(getPoImagePreview(object));
            setPreviewImage(true);
        }
    };

    const poAttachedImage = isAttachment ? isAttachment[0] : null;

    return (
        <>
            {poAttachedImage ? (
                <FileLinkImage
                 id="orders-po-info-view-file-link-image"
                    onClick={() => openImagePreview(poAttachedImage)}
                    src={FileLink}
                />
            ) : null}
            {previewImage && (
                <PoImagePreview
                    closePoImagePreview={(e) => {
                        setPreviewImage(false);
                        e.stopPropagation();
                    }}
                />
            )}
        </>
    );
};

export default PoInfoView;

// const AlertTextDiv = styled.div`
//     display: flex;
//     align-items: center;
//     margin-left: 2.5vw;
//     ${media.mobileDevice`
//         align-items: flex-start;
//         margin-left: 0px;
//     `};
//     ${media.smalDevice`
//         align-items: flex-start;
//         margin-left: 0px;
//     `};
// `;

const FileLinkImage = styled.img.attrs((props) => ({
    src: props.src,
}))`
    width: 24px;
    height: 24px;
    cursor: pointer;
    margin-right: 2px;
`;
